// default
export const CHART_DASHBOARD = 'chartDashboard';
export const CHART_DASHBOARD_SLICE_NAME = `${CHART_DASHBOARD}Slice`;

// action
export const GET_CHART_DASHBOARD_PROJECT = `${CHART_DASHBOARD}/GET_CHART_DASHBOARD_PROJECT`;

export const chartDashboardActionList = {
  GET_CHART_DASHBOARD_PROJECT
};
